<template>
  <generic-modal :title="$t('message')" ref="generic_modal">
    <pre>{{ message }}</pre>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  post,
  generate_error_message_text,
  get,
  format_date_time,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import "bulma-extensions/bulma-timeline/dist/css/bulma-timeline.min.css";

export default {
  name: "MessageModal",
  components: { GenericModal },
  props: {},
  data() {
    return {
      message: [],
      error: "",
    };
  },
  computed: {},
  methods: {
    format_date_time,
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal(uuid) {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
      v.$root.loader(true);
      get("/whatsapp/message", { uuid: uuid })
        .then((res) => {
          v.message = res;
        })
        .catch((err) => {
          v.error = generate_error_message_text(err);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    set_initial_state() {
      let v = this;
      v.message = {};
      v.error = "";
    },
  },
  mounted() {},
  created() {},
  watch: {},
};
</script>
<style></style>
